<table mat-table [dataSource]="dataSource" [ngClass]="formatElevation()">

  <div *ngFor="let column of displayedColumns; first as isFirst;">
    <ng-container matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef [ngClass]="{'vertical-separator': options.verticalSeparator}">
        {{options.capitalisedHeader ? (column | anessaTranslation | titlecase) : (column | anessaTranslation)}}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="{'vertical-separator': options.verticalSeparator}">
        <div *ngIf="isFirst">
          <div class="value-cell">
            <div [innerHTML]="formatIndentation(element)"></div>
            <mat-icon *ngIf="element.children.length" [ngStyle]="{'visibility': element.children.length ? 'visible' : 'hidden'}" (click)="onNodeClick(element)">
              {{element.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}
            </mat-icon>
            <div [innerHTML]="element.value[column]" style="padding: 10px;"></div>
            <mat-icon *ngIf="element.value['INFO_TOOLTIP']" [matTooltip]="element.value['INFO_TOOLTIP']">info</mat-icon>
          </div>
        </div>
        <div *ngIf="!isFirst" [innerHTML]="element.value[column]">
        </div>
      </td>
    </ng-container>
  </div>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row [ngClass]="{'highlight-on-hover': options.highlightRowOnHover}" *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
